import React, { useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/AccountSetting.css";
import { background2 } from "../../Constant";
import { connect } from "react-redux";
import config from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faStar } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { UpdateProfileAction } from "../../redux/actions/auth";
import moment from "moment";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

const EditProfile = ({ auth, updateProfile, states }) => {
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState(auth.user.first_name || "");
    const [lastName, setLastName] = useState(auth.user.last_name || "");
    const [height, setHeight] = useState(auth.user.height || "");
    const [weight, setWeight] = useState(auth.user.weight || "");
    const [phoneNo, setPhoneNo] = useState(auth.user.phone_no || "");
    const [email, setEmail] = useState(auth.user.email || "");
    const [profilePic, setProfilePic] = useState(null);
    const [address1, setAddress1] = useState(auth.user.address_1 || "");
    const [address2, setAddress2] = useState(auth.user.address_2 || "");
    const [city, setCity] = useState(auth.user.city || "");
    const [state, setState] = useState(auth.user.state || "");
    const [zip, setZip] = useState(auth.user.zip || "");
    const [dob, setDob] = useState(auth.user.dob || "");
    const [emergencyMobileNumber, setEmergencyMobileNumber] = useState(
        auth.user.emergency_mobile_number || ""
    );
    const [emergencyName, setEmergencyName] = useState(
        auth.user.emergency_name || ""
    );
    const [maxDistance, setMaxDistance] = useState(
        auth.user.max_distance || ""
    );
    const [emergencyMembersName, setEmergencyMembersName] = useState(
        auth.user.emergency_members_name || ""
    );
    const [dobDate, setDobDate] = useState(
        moment(auth.user.dob).format("DD").padStart(2, "0")
    );
    const [dobMonth, setDobMonth] = useState(
        moment(auth.user.dob).format("MM").padStart(2, "0")
    );
    const [dobYear, setDobYear] = useState(
        moment(auth.user.dob).format("YYYY")
    );
    const [gender, setGender] = useState(auth.user.gender || "");
    console.log(gender);
    const [bio, setBio] = useState(auth.user.bio || "");

    const submit = async () => {
        try {
            let formdata = new FormData();
            formdata.append("first_name", firstName);
            formdata.append("last_name", lastName);
            formdata.append("height", height);
            formdata.append("weight", weight);
            formdata.append("phone_no", phoneNo);
            formdata.append("address_1", address1);
            formdata.append("address_2", address2);
            formdata.append("city", city);
            formdata.append("state", state);
            formdata.append("zip", zip);
            // formdata.append("emergency_members_name", emergencyMembersName);
            formdata.append("emergency_name", emergencyName);
            formdata.append("emergency_mobile_number", emergencyMobileNumber);
            // let dob = dobYear + "-" + dobMonth + "-" + dobDate;
            formdata.append("dob", dob);
            formdata.append("max_distance", maxDistance);
            formdata.append("gender", gender);
            formdata.append("bio", bio);
            if (profilePic) {
                formdata.append("image", profilePic);
            }

            updateProfile(formdata).then(() => {
                navigate("/profile");
            });
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <Header />
            {/* <!-- Account Setting Start here --> */}
            <section className="account_setting">
                <div className="container-fluid">
                    <div className="profile_details">
                        <div className="profile_img">
                            <figure>
                                <img
                                    src={config.returnImage(auth.user)}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="detailsDv">
                            <div className="profile_detailed_box">
                                <div className="left_detail">
                                    <div className="top_detail_wrapper">
                                        <h3 className="name">
                                            {auth.user.full_name}
                                        </h3>
                                        {auth.user.role == 2 && (
                                            <div className="rating">
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        config.starActiveColor
                                                    }
                                                />
                                                {/* <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i> */}
                                                <span className="rates">
                                                    {
                                                        auth.user
                                                            .rating_by_customer
                                                    }
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="address_strip">
                                        <div className="address">
                                            <FontAwesomeIcon
                                                icon={faMapMarker}
                                            />
                                            {/* <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                            ></i> */}
                                            <span>
                                                {auth.user.full_address}
                                            </span>
                                        </div>
                                        {/* <div className="response_time">
                                            <FontAwesomeIcon icon={faClock} />
                                            <span>
                                                Average Response Time: 1 Hour
                                            </span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="right_detail">
                                    <div className="buttons-group">
                                        <button
                                            className="btn chat_btn"
                                            type="button"
                                            onClick={submit}
                                        >
                                            Save Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="account_details mt-4">
                        <div className="row">
                            <div className="col-lg-9">
                                <div className="heading_wrapper pb-4">
                                    <h5>Account </h5>
                                    <p>
                                        Set up your profile within 2-minutes
                                        whether you wish to deliver caregiving
                                        services or want to hire our
                                        professional care.
                                    </p>
                                </div>
                                <form encType="multipart/form-data">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="profile_pic">
                                                    Profile Picture
                                                </label>
                                                <input
                                                    className="form-control form-imgInput"
                                                    type={"file"}
                                                    accept="image/*"
                                                    onChange={(e) =>
                                                        setProfilePic(
                                                            e.target.files[0]
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="fname">
                                                    First Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="fname"
                                                    // value="James"
                                                    className="form-control"
                                                    value={firstName}
                                                    onChange={(e) =>
                                                        setFirstName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="lname">
                                                    Last Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="lname"
                                                    className="form-control"
                                                    value={lastName}
                                                    onChange={(e) =>
                                                        setLastName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="height">
                                                    Height
                                                </label>
                                                <input
                                                    step={0.01}
                                                    type="number"
                                                    id="height"
                                                    className="form-control"
                                                    value={height}
                                                    onChange={(e) =>
                                                        setHeight(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="weight">
                                                    Weight
                                                </label>
                                                <input
                                                    step={0.01}
                                                    type="number"
                                                    id="weight"
                                                    className="form-control"
                                                    value={weight}
                                                    onChange={(e) =>
                                                        setWeight(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div> */}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="address1">
                                                    Address 1
                                                </label>
                                                <input
                                                    type="text"
                                                    id="address1"
                                                    className="form-control"
                                                    value={address1}
                                                    onChange={(e) =>
                                                        setAddress1(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="address2">
                                                    Address 2
                                                </label>
                                                <input
                                                    type="text"
                                                    id="address2"
                                                    className="form-control"
                                                    value={address2}
                                                    onChange={(e) =>
                                                        setAddress2(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="city">
                                                    City
                                                </label>
                                                <input
                                                    type="text"
                                                    id="city"
                                                    className="form-control"
                                                    value={city}
                                                    onChange={(e) =>
                                                        setCity(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="state">
                                                    State
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="state"
                                                    value={state}
                                                    onChange={(e) =>
                                                        setState(e.target.value)
                                                    }
                                                >
                                                    <option value={null}>
                                                        Select State
                                                    </option>
                                                    {states.map((state) => (
                                                        <option
                                                            key={state.id}
                                                            value={state.id}
                                                        >
                                                            {state.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="zip">Zip</label>
                                                <input
                                                    type="text"
                                                    id="zip"
                                                    className="form-control"
                                                    value={zip}
                                                    onChange={(e) =>
                                                        setZip(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="phone">
                                                    Phone
                                                </label>
                                                <input
                                                    type="tel"
                                                    id="phone"
                                                    className="form-control"
                                                    value={phoneNo}
                                                    onChange={(e) =>
                                                        setPhoneNo(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="max_distance">
                                                    Max Distance
                                                </label>
                                                <input
                                                    type="number"
                                                    id="max_distance"
                                                    placeholder={"Add Distance in Meters"}
                                                    className="form-control"
                                                    value={maxDistance}
                                                    onChange={(e) =>
                                                        setMaxDistance(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="pemail">
                                                    Primary Email
                                                </label>
                                                <input
                                                    type="email"
                                                    id="pemail"
                                                    className="form-control"
                                                    value={email}
                                                    onChange={(e) =>
                                                        setEmail(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="emergency_members_name">
                                                    Emergency Members Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="emergency_members_name"
                                                    className="form-control"
                                                    value={emergencyMembersName}
                                                    onChange={(e) =>
                                                        setEmergencyMembersName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div> */}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="emergency_name">
                                                    Emergency Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="emergency_name"
                                                    className="form-control"
                                                    value={emergencyName}
                                                    onChange={(e) =>
                                                        setEmergencyName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="emergency_mobile_number">
                                                    Emergency Mobile Number
                                                </label>
                                                <input
                                                    type="text"
                                                    id="emergency_mobile_number"
                                                    className="form-control"
                                                    value={
                                                        emergencyMobileNumber
                                                    }
                                                    onChange={(e) =>
                                                        setEmergencyMobileNumber(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="dob_date">
                                                    Dob (Date)
                                                </label>
                                                <select
                                                    value={dobDate}
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setDobDate(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value={null}>
                                                        Select Day
                                                    </option>
                                                    {new Array(31)
                                                        .fill()
                                                        .map((a, date) => (
                                                            <option
                                                                key={(date + 1)
                                                                    .toString()
                                                                    .padStart(
                                                                        2,
                                                                        "0"
                                                                    )}
                                                                value={(
                                                                    date + 1
                                                                )
                                                                    .toString()
                                                                    .padStart(
                                                                        2,
                                                                        "0"
                                                                    )}
                                                            >
                                                                {(date + 1)
                                                                    .toString()
                                                                    .padStart(
                                                                        2,
                                                                        "0"
                                                                    )}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="dob_date">
                                                    Dob (Month)
                                                </label>
                                                <select
                                                    value={dobMonth}
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setDobMonth(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value={null}>
                                                        Select Month
                                                    </option>
                                                    {new Array(12)
                                                        .fill()
                                                        .map((a, date) => (
                                                            <option
                                                                key={(date + 1)
                                                                    .toString()
                                                                    .padStart(
                                                                        2,
                                                                        "0"
                                                                    )}
                                                                value={(
                                                                    date + 1
                                                                )
                                                                    .toString()
                                                                    .padStart(
                                                                        2,
                                                                        "0"
                                                                    )}
                                                            >
                                                                {moment(
                                                                    date + 1,
                                                                    "MM"
                                                                ).format(
                                                                    "MMMM"
                                                                )}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="dob_year">
                                                    Dob (Year)
                                                </label>
                                                <select
                                                    value={dobYear}
                                                    onChange={(e) =>
                                                        setDobYear(
                                                            e.target.value
                                                        )
                                                    }
                                                    className="form-control"
                                                    id="dob_year"
                                                >
                                                    <option>Select Year</option>
                                                    {new Array(40)
                                                        .fill()
                                                        .map((a, year) => (
                                                            <option
                                                                key={
                                                                    parseInt(
                                                                        moment().format(
                                                                            "YYYY"
                                                                        )
                                                                    ) -
                                                                    (year + 18)
                                                                }
                                                            >
                                                                {parseInt(
                                                                    moment().format(
                                                                        "YYYY"
                                                                    )
                                                                ) -
                                                                    (year + 18)}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Date of Birth</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={dob}
                                                    onChange={(e) =>
                                                        setDob(e.target.value)
                                                    }
                                                />
                                                {/* <DatePicker placeholderText="Select Date of Birth" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="gender">
                                                    Gender
                                                </label>
                                                <select
                                                    className="form-control"
                                                    value={gender}
                                                    onChange={(e) =>
                                                        setGender(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value={null}>
                                                        Select Gender
                                                    </option>
                                                    <option value={0}>
                                                        Male
                                                    </option>
                                                    <option value={1}>
                                                        Female
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4">
                                            
                                        </div> */}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="bio">Bio</label>
                                        <textarea
                                            className="form-control bio-field"
                                            value={bio}
                                            onChange={(e) =>
                                                setBio(e.target.value)
                                            }
                                            rows={20}
                                        ></textarea>
                                    </div>
                                </form>
                                <div className="introduction_dv">
                                    <h4>How to Set Up Your Profile? </h4>
                                    <p>
                                        It’s easy to create your profile with My
                                        Home Helper. All you have to do is
                                        provide the required fields’
                                        information. It is important that you
                                        insert your true and accurate
                                        information to avoid any problems in the
                                        future. Please note that inaccurate or
                                        wrongful information may lead to the
                                        termination of your account. Read our
                                        terms and conditions to know more about
                                        our policy related to account
                                        registration.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="side_bar_box">
                                    <div className="img_box">
                                        <figure>
                                            <img src={background2} alt="" />
                                        </figure>
                                    </div>
                                    <div className="contentDv">
                                        <h5>
                                            Why Create a Profile With My Home
                                            Helper?
                                        </h5>
                                        <p>
                                            My Home Helper is exclusively
                                            established to cater to the
                                            caregiving needs of individuals. Our
                                            sole purpose is to help our client
                                            reach their goals with little to no
                                            effort.
                                        </p>
                                        <ul
                                            className="list"
                                            style={{ paddingBottom: 40 }}
                                        >
                                            <li>
                                                <i
                                                    className="fa fa-star"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Quick Turnaround Time
                                            </li>
                                            <li>
                                                <i
                                                    className="fa fa-star"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Professional Services
                                            </li>
                                            <li>
                                                <i
                                                    className="fa fa-star"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                24/7 Customer Support
                                            </li>
                                        </ul>
                                        {/* <div className="button-group">
                                            <a href="#" className="btn">
                                                Loem Ipsum
                                            </a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Account Setting End here --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
    updateProfile: async (payload) =>
        dispatch(await UpdateProfileAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
